import React, { useEffect, useState } from 'react';
import { Flex } from 'antd';
import accountOperatorApi from '../../../api/account';
import WidgetCard from '../../widgets/WidgetCard';
import AccountHeader from './AccountHeader';
import '../../../styles/account/account.css';
import AccountInfo from './AccountInfo';
import AccountUser from './AccountUser';
import { useSelector } from 'react-redux';
const AccountSetting = () => {
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEdit, setIsEdit] = useState(true);
  const [reload, setReload] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        setLoading(true);
        const res = await accountOperatorApi.get();
        if (res) {
          setAccount(res);
          setLoading(false);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetch();
  }, [reload]);

  const onReload = () => {
    setReload((reload) => !reload);
  };

  return (
    <>
      <AccountHeader account={account} />
      <WidgetCard
        bordered={false}
        style={{ minHeight: '100vh' }}
        loading={loading}>
        <Flex style={{ width: '100%' }}>
          <AccountUser
            account={account}
            setAccount={setAccount}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            onReload={onReload}
          />
        </Flex>
      </WidgetCard>
    </>
  );
};

export default AccountSetting;
